import { ExamineArtifactCommand } from "../../core/commands/ExamineArtifactCommand";
import { getComponent } from "../../world/Entity";
import type { Interaction, InteractionContext } from "../Interaction";
import type { ArtifactComponent, EntityComponent } from "../../world/components";

function discoveredArtifact(ctx: InteractionContext): ArtifactComponent | undefined {
  if (ctx.entity) {
    const artifact = getComponent(ctx.entity, "artifact");
    return artifact !== undefined && artifact.discovered ? artifact : undefined;
  }
  if (ctx.inventoryItem) {
    const components = (ctx.inventoryItem.metadata as { components?: readonly EntityComponent[] } | undefined)?.components;
    const artifact = components?.find((c): c is ArtifactComponent => c.type === "artifact");
    return artifact !== undefined && artifact.discovered ? artifact : undefined;
  }
  return undefined;
}

/** Examine an artifact more closely — reveals hidden details and progresses knowledge. */
export const examineInteraction: Interaction = {
  id: "examine",
  label: "Examine",
  canExecute: (ctx) => discoveredArtifact(ctx) !== undefined,
  execute: async (ctx) => {
    if (ctx.entity) {
      if (!discoveredArtifact(ctx)) return { success: false, message: "Nothing to examine." };
      ctx.commands.execute(new ExamineArtifactCommand(ctx.entity.id));
      return { success: true };
    }
    if (ctx.inventoryItem) {
      if (!discoveredArtifact(ctx)) return { success: false, message: "Nothing to examine." };
      ctx.commands.execute(new ExamineArtifactCommand(ctx.inventoryItem.instanceId));
      return { success: true };
    }
    return { success: false, message: "Nothing to examine." };
  },
};
